// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03f91ada","797":"0f93f5fc"}[chunkId] + ".chunk.js";
};